// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"30183297","358":"48a55f35","377":"25273e78"}[chunkId] + ".chunk.js";
};